import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = {
  key: 0,
  class: "card-outlined md:py-2 md:px-4"
}
const _hoisted_3 = { class: "flex items-center justify-between px-2 mb-2" }
const _hoisted_4 = { class: "text-green-600 text-2xl" }
const _hoisted_5 = { class: "md:py-2 md:px-4" }
const _hoisted_6 = { class: "flex items-center justify-between border-gray-300 border-b px-2 mb-2" }
const _hoisted_7 = { class: "hover:text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.qa_sub_categories)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qa_sub_categories, (qa_sub_category) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: qa_sub_category.id,
                      class: "px-1 pt-1.5 pb-2"
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h1", _hoisted_4, _toDisplayString(qa_sub_category.name), 1),
                          _createElementVNode("ul", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa_sub_category.qa_lists, (qa_list) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: qa_list.id,
                                class: "px-1 pt-1.5 pb-2"
                              }, [
                                _createVNode(_component_router_link, {
                                  to: `/qa/list/`+ qa_list.id
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      _createElementVNode("div", _hoisted_7, _toDisplayString(qa_list.question_title), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" ページが見つかりませんでした。 ")
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}